<template>
    <div>
        <h2>{{ $t("monte.article_valider_poulain") }}</h2>
        <div class="box">

            <SeasonInput v-model="seasonSelected" @change="changeSeason" :selectPreviousDefault="true" />

            <div class="row mt-3">
                <div class="col-12">
                    <b-form-checkbox
                        class="custom-control"
                        v-model="display_zero"
                    >
                        {{ $t("invoice.afficher_montant_zero") }}
                    </b-form-checkbox>
                </div>
            </div>

            <CustomTable
                :id_table="id_table"
                :items="a_valider"
                :busy.sync="table_busy"
                primaryKey="increment"
                :hide_if_empty="true"
                :hrefsRoutes="config_table_hrefs"
                :rawColumns="rawColumnNames"
                ref="aValiderTable"
            />
        </div>

        <ModalConfirm
            ref="confirm_a_valider"
            id="confirm_a_valider_c"
            :icon="['far', 'check']"
            :icon_accept="['fal', 'level-down']"
            :text_title="$t('modal.invoice.validation_a_valider')"
            :text_question="$t('modal.invoice.text_validation_a_valider')"
            :text_button_ok="$t('modal.general.ok')"
            :text_button_cancel="$t('modal.general.annuler')"
            :callback_validation="valideFacturationAValider"
            :callback_cancel="cancelSwitchAValiderModal"
            :processing="processing_a_valider"
        />

        <b-modal
            ref="processing_modal"
            :title="$t('invoice.processing_valid')"
            hide-footer
        >
            <b-progress show-progress height="2rem" :max="total">
                <b-progress-bar :value="processed" :label="`${((processed / total) * 100).toFixed(0)}%`"></b-progress-bar>
            </b-progress>
            <h5 class="text-center mt-2">
                {{ $t('invoice.total_valid', {total, processed}) }}
            </h5>
        </b-modal>
    </div>
</template>


<script type="text/javascript">
    import { EventBus } from 'EventBus'
    import Common from '@/assets/js/common.js'
    import Invoice from "@/mixins/Invoice.js"
    import Navigation from "@/mixins/Navigation.js"

    export default {
        name: "aValiderPoulain",
        mixins: [Invoice, Navigation],
        props: {
            options: {
                type: Object,
                default: () => ({
                    type: 'Invoice',
                    id: null,
                })
            }
        },
        data () {
            return {
				id_table: "contract_poulain_a_valider",
                a_valider: null,
                table_busy: true,
                events_tab: {
                    'TableAction::goToValideFacturationAValider': this.valideFacturationCheck,
                },
                rawColumnNames: ['horse_nom', 'date_poulain', 'contract_note'],
                config_table_hrefs: {
					'contract_num': {
						routeUniqueName: 'ContractForm',
						routeName: 'ContractFormv2',
						params: {
							contract_id: 'contract_id'
						}
					},
                    'horse_nom': {
                        routeUniqueName: 'horseFiche',
                        routeName: 'horseFiche',
                        params: {
                            horse_id: 'horse_id'
                        }
                    }
                },
                seasonSelected: null,
                display_zero: false,
                processing_a_valider: false,
                horse_actes: null,
                total: 0,
                processed: 0
            }
		},
        watch: {
            display_zero() {
                this.changeSeason()
            }
        },
        mounted() {
            this.init_component()
        },
        methods: {
            async init_component() {
                this.changeSeason()
            },
            async loadAValider(season_id) {
                this.table_busy = true

                const a_valider = await this.loadFacturationAValiderMontePoulain(season_id, this.display_zero)
                this.a_valider = await this.formatAValider(a_valider)

				this.table_busy = false
            },
			async formatAValider(a_valider) {
				let avalider = []
                if(!a_valider) {
                    return []
                }
                let increment = 0

                if(a_valider) {
                    for(let i = 0; i < a_valider.length; i++) {
                        increment ++
                        let temp = a_valider[i]

                        temp.contract_label = temp.articles_label
                        temp.increment = increment

                        temp.href = "horseFiche"
                        temp.params = { horse_id: temp.horse_id }

                        temp.ht_no_format = temp.ht
                        // temp.ht = await this.priceFormat(temp.ht, temp.author_currency)

                        if(temp.acte_dg && temp.acte_dg.reponses && temp.acte_dg.reponses.length > 0) {
                            const date_dg = Date.parseTz(temp.acte_dg.actes_date)
                            temp.last_dg = temp.acte_dg.reponses[0].reponse_data[0] + " (" + this.formatDate(date_dg) + ")"
                        }

                        temp.date_poulain = null

                        if(temp.acte_poulain) {
                            temp.date_poulain = Date.parseTz(temp.acte_poulain.actes_date)

							const reponses = temp.acte_poulain.reponses
							if (reponses && reponses.length) {
								const isAlive = reponses[0].reponse_data[0] === 'Poulain vivant'
								temp.customClasses = {
									'date_poulain': isAlive ? 'poulain-vivant' : 'poulain-mort'
								}
							}
                        }

                        if(temp.date_terme)
                        {
                            temp.date_terme = this.formatDate(Date.parseTz(temp.date_terme))
                        }
						
                        temp.status = this.getTrad(temp.status)
                        temp.seasonmarestallion_status = temp.seasonmarestallion_status ? Common.translateSeasonMareStatus(temp.seasonmarestallion_status) : null

                        avalider.push(temp)
                    }
                }

                return avalider
			},
            valideFacturationCheck(horse_actes) {
                const now = new Date();
                const isCurrentSeason = (now > new Date(this.seasonSelected.begin) && now < new Date(this.seasonSelected.end))
                this.horse_actes = horse_actes
                if (isCurrentSeason) {
                    return this.$refs.confirm_a_valider.openModal()
                }
                return this.valideFacturationAValider()
            },
            cancelSwitchAValiderModal() {
				this.$refs.confirm_a_valider.closeModal()
			},
            async valideFacturationAValider() {
                this.processing_a_valider = true
                let horse_actes = this.horse_actes
                let paramsToSend = {};
                paramsToSend['details'] = []
                paramsToSend['pensions'] = []
                let result_invoice_details = false
                let max_processing = 50

                if(horse_actes) {
                    this.total = horse_actes.length
                    if(this.total > max_processing) {
                        this.$refs.processing_modal.show()
                    }

                    for(let i = 0; i < horse_actes.length; i++) {
                        let discount_type = horse_actes[i].discount_type ? {
                            invoicediscounttype_id: horse_actes[i].discount_type,
                            invoicediscounttype_type: horse_actes[i].discount_type == 1 ? 'pourcentage' : 'numeraire'
                        } : null
                        
                        paramsToSend.details.push({
                            author_id: horse_actes[i].author_id,
                            tiers_id: horse_actes[i].tiers_id,
                            qte: 1,
                            htunit: horse_actes[i].ht_before_discount,
                            vat: horse_actes[i].vat,
                            horse_id: horse_actes[i].horse_id,
                            articles_id: horse_actes[i].articles_id,
                            actes_id: horse_actes[i].actes_id,
                            description: '',
                            invoicedetails_avenantarticles: horse_actes[i].avenantarticles_id,
                            invoicedetails_contract: horse_actes[i].contract_id,
                            label: horse_actes[i].articles_label,
                            avenantarticles_id: horse_actes[i].avenantarticles_id,
                            contract_id: horse_actes[i].contract_id,
                            discount_type: discount_type,
                            discount_value: horse_actes[i].discount_value,
                            ht_initial: horse_actes[i].ht_initial ?? horse_actes[i].ht_before_discount * 100,
                            tiershorsepartpart: horse_actes[i].quote_part,
                            tiershorseparttype: 3
                        })

                        if(((i+1)%max_processing == 0 || (i+1) == this.total) && paramsToSend) {
                            result_invoice_details = await this.createInvoiceDetails(paramsToSend)
                            this.processed = i+1
                            paramsToSend = {
                                'details': [],
                                'pensions': []
                            }
                        }
                    }
                }

                this.$refs.processing_modal.hide()
                EventBus.$emit("TableAction::stopSpin")

                if(result_invoice_details) {
                    this.$router.push({name: 'invoiceBons'})
                }
                else {
                    this.failureToast();
                    this.$refs["aValiderTable"].unselectAll()
                    this.changeSeason()
                }
                this.processing_a_valider = false
            },

            async changeSeason() {
                if(!this.seasonSelected) return
                this.loadAValider(this.seasonSelected.id)
            }
        },
        components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
            SeasonInput : () => import('@/components/Inputs/SeasonInput'),
            ModalConfirm : () => import('@/components/Modals/ModalConfirm')
        }
    }
</script>
